import { PatsnapCopilotService } from './patsnap-copilot-service.interface';
import type { PatsnapCopilotUsage } from './patsnap-copilot-service.interface';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';

export function wujieOptions(config: {
    url: string;
    patsnapCopilotUsage: PatsnapCopilotUsage;
    service?: PatsnapCopilotService;
 }): {
    name: string,
    alive: boolean,
    url: string,
    props: {
        patsnapCopilotService: () => PatsnapCopilotService,
    },
} {
    return {
        name: 'analytics:patsnap-copilot',
        alive: true,
        url: config.url,
        props: {
            patsnapCopilotService: () => {
                let service = config && config.service;
                if (!service) {
                    service = injectService<PatsnapCopilotService>(PatsnapCopilotService);
                }
                service.patsnapCopilotUsage = config.patsnapCopilotUsage;
                return service;
            },
        }
    }
}
